<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Processo de Compra</h1>
        <paragrafo
          ><li>Escolha o produto e selecione “Comprar agora”.</li></paragrafo
        >
        <paragrafo
          ><li>
            Determine a quantidade de produtos que o cliente deseja utilizando
            os sinais de mais (+) e menos (-).
          </li>
        </paragrafo>
        <paragrafo
          ><li>
            Caso seja só esse produto, selecionar “Finalizar compra”.
          </li></paragrafo
        >
        <paragrafo
          ><li>
            Caso desejar mais produtos, selecionar
            <negrito>“Comprar mais”</negrito> e escolher a quantidade de
            produtos, após isso selecionar
            <negrito>“Finalizar compra”</negrito>.
          </li></paragrafo
        >
        <v-row justify="center">
          <imagem :src="image_1" />
        </v-row>
        <paragrafo
          ><li>
            Serão mostrados todos os produtos que estão no carrinho. Nesse
            momento é possível excluir cada um deles ou selecionar “Esvaziar”
            para retirar todos ao mesmo tempo.
          </li></paragrafo
        >
        <v-row justify="center">
          <imagem :src="image_2" />
        </v-row>
        <paragrafo
          ><li>Veja abaixo as telas das formas de pagamento:</li></paragrafo
        >
        <paragrafo
          ><negrito><v-row justify="center">Crédito</v-row></negrito></paragrafo
        >
        <paragrafo
          ><v-row justify="center"><imagem :src="image_3" /></v-row
        ></paragrafo>
        <paragrafo
          ><negrito><v-row justify="center">Pix</v-row></negrito></paragrafo
        >
        <paragrafo
          ><v-row justify="center"><imagem :src="image_4" /></v-row
        ></paragrafo>
        <paragrafo
          ><negrito
            ><v-row justify="center">Dinheiro</v-row></negrito
          ></paragrafo
        >
        <paragrafo
          ><v-row justify="center"><imagem :src="image_5" /></v-row
        ></paragrafo>
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Processo de Compra",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem_pos.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/pos/imagensPOS/compradatahora.png",
      image_2: "/pos/imagensPOS/compra2.png",
      image_3: "/pos/imagensPOS/compra3.png",
      image_4: "/pos/imagensPOS/compra4.png",
      image_5: "/pos/imagensPOS/compra5.png",
    };
  },
};
</script>
